export const faqQuestions = [
  {
    header: "What is HomeSwap?",
    answer:
      "HomeSwap is a service that allows people to exchange their homes for vacations and/or student-abroad travels.\n\n Members can stay in each other's homes, providing an affordable and immersive travel experience.",
  },
  {
    header: "What are the advantages of using HomeSwap?",
    answer:
      "Opting for a home swap provides numerous benefits. Firstly, it offers significant cost savings by eliminating accommodation expenses entirely. Additionally, it provides the comfort and amenities of a full home, enhancing your travel experience.\n\n The flexibility of home swapping is remarkable, with a wide variety of home types and locations available worldwide. Moreover, it promotes sustainable travel by making use of existing resources, thus supporting eco-friendly practices.",
  },
  {
    header: "What is the HomeSwap community?",
    answer:
      "The HomeSwap community is a global network of members who participate in home exchanges for vacation, travel purposes or study-abroad semesters. It's a supportive community of like-minded individuals who want to share their homes and build connections across the globe.",
  },
  {
    header: "How do I sign up?",
    answer:
      "In order to join the HomeSwap community, all you have to do is sign-up and become a member, free of charge, on the website. ",
  },
] as const;
